module.exports = require('./helpers/bundle-url').getBundleURL('kmvYf') + "markus-faeh.24e5e941.jpg" + "?" + Date.now();